// extracted by mini-css-extract-plugin
export default {"heroContainer":"iUB053","termsBanner":"vFGJY8"};